// extracted by mini-css-extract-plugin
export default {"switcher":"styles_switcher__36Qb5"};